import { PayoutFeeConfig } from 'src/app/types/PayoutFeeConfig';
import { AffiliateCommission } from '../../types/AffiliateCommission';
import { AffiliateVendor } from '../../types/AffiliateVendor';

export abstract class IAffiliatesService {
  abstract getAffiliateVendors(): Promise<{
    affiliate_code: string;
    affiliate_vendors: AffiliateVendor[];
    is_premium_affiliate_manager: boolean;
  }>;

  abstract updatePayoutFeeConfig(
    affiliateVendorId: string,
    payoutFeeConfig: PayoutFeeConfig,
  ): Promise<void>;

  abstract getAffiliateCommissions(): Promise<{
    total_commission_earned_amount: number;
    affiliate_commissions: AffiliateCommission[];
  }>;
}
